/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
    readonly " $refType": "AccountNav_viewer";
};
export type AccountNav_viewer$data = AccountNav_viewer;
export type AccountNav_viewer$key = {
    readonly " $data"?: AccountNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNavContent_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c3ac0a44332509c1ef9d29b8c32a830c';
export default node;
